// extracted by mini-css-extract-plugin
export default {"loading-container":"Loading_loading-container__lv7HK","loading-dot":"Loading_loading-dot__I3oWs","loadingAnimation":"Loading_loadingAnimation__ERCTM"};